var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outlined-label",class:{'active': _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }